exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".QuestionMylty{margin-left:10px;margin-right:10px;margin-top:0;display:flex;flex-direction:column;align-items:center;justify-content:center;flex:auto;width:90%;min-width:910px}.QuestionMylty .title_text{width:100%}.QuestionMylty .actions{margin-top:20px;margin-bottom:20px;position:relative}.QuestionMylty .actions .bt_gray{background:#fff;border:2px solid #98a1b3;box-sizing:border-box;box-shadow:0 2px 0 #98a1b3;color:#98a1b3}.QuestionMylty .actions .bt_gray:active,.QuestionMylty .actions .bt_gray:hover{box-shadow:0 3px 0 #98a1b3!important}.QuestionMylty .actions .custom-button+.custom-button{margin-left:150px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./yii2/frontend/frontend-assets/src/components/QuestionMultyView/components/Question/style.module.scss
// module id = 5239
// module chunks = 0